<template>

	<!-- page content -->
	<div class="container-fluid">
		<div class="row">
			<div class="col-lg-12 col-md-12 col-sm-12 mx-auto user-panel mb-5">

				<div class="row page-header">
					<div class="col">
						<h3>Settings</h3>
					</div>
				</div>

				<div class="row mt-3">


					<div class="col-md-3">
						<ul class="nav">
							<div class="card card-default panel-flush panel-dark w-100">
								<div class="card-header">
									Settings Navigation
								</div>

								<div class="nav flex-column nav-pills settings-stacked-tabs" id="v-pills-tab" role="tablist" aria-orientation="vertical">
									<a class="nav-link active" id="v-pills-account-tab" data-toggle="pill" href="#v-pills-account" role="tab" aria-controls="v-pills-account" aria-selected="true">Account</a>
									<a class="nav-link" id="v-pills-password-tab" data-toggle="pill" href="#v-pills-password" role="tab" aria-controls="v-pills-password" aria-selected="false">Password</a>
									<a class="nav-link" id="v-pills-social-tab" data-toggle="pill" href="#v-pills-social" role="tab" aria-controls="v-pills-social" aria-selected="false">Social</a>
								</div>
							</div>
						</ul>
					</div>


					<div class="col">

						<div class="alert alert-danger mb-3" v-if="error && error !== null">
							Whoops! {{ messageText }}
						</div>

						<div class="alert alert-success mb-3" v-if="!error && error !== null">
							Success! {{ messageText }}
						</div>

						<div class="card card-default panel-flush panel-dark w-100">
							
							<div class="card-body">
								<div class="tab-content" id="v-pills-tabContent">
									<div class="tab-pane fade show active" id="v-pills-account" role="tabpanel" aria-labelledby="v-pills-account-tab">

										<div class="form-group row">
											<label for="address" class="col-sm-3 col-form-label text-left d-flex align-items-center fw-600">Address</label> 
											<div class="col-sm-9">
												<input type="text" placeholder="3983 Example Street" class="form-control" v-model="settings.address">
											</div>
										</div>

										<div class="form-group row">
											<div class="col-md-3"></div>
											<div class="col-md-5 form-group">
												<input type="text" placeholder="Childersbugh" class="form-control" v-model="settings.city">
											</div>
											<div class="col-md-2 form-group">
												<input type="text" placeholder="AL" class="form-control" v-model="settings.state">
											</div>
											<div class="col-md-2 form-group">
												<input type="number" placeholder="35044" class="form-control" v-model="settings.zipcode">
											</div>
										</div>


										<div class="form-group row">
											<label for="phone" class="col-sm-3 col-form-label text-left d-flex align-items-center fw-600">Phone Number</label> 
											<div class="col-sm-9">
												<input type="number" id="phone" placeholder="123-456-7890" class="form-control" v-model="settings.phone">
											</div>
										</div>

										<div class="row">
											<div class="col-md-12 text-left">
												<strong>Notice: </strong> Do not enter any special characters in the phone number: <code>-, (, )</code>. <br /> <br />
											</div>
										</div>

										<div class="form-group row mt-3">
											<div class="col text-center">
												<button class="btn btn-primary" v-on:click="updateSettings">
													<span v-if="!updating">Update</span>
                                					<span v-if="updating"><i class="fa fa-circle-o-notch fa-spin logging-in"></i></span>
												</button>
											</div>
										</div>

									</div>

									<div class="tab-pane fade" id="v-pills-password" role="tabpanel" aria-labelledby="v-pills-password-tab">

										<div class="form-group row">
											<label for="pw-old" class="col-sm-3 col-form-label text-left d-flex align-items-center fw-600">Old Password</label>
											<div class="col-sm-9">
												<input type="password" class="form-control" id="pw-old" v-model="password.old">
											</div>
										</div>

										<div class="form-group row">
											<label for="pw-old" class="col-sm-3 col-form-label text-left d-flex align-items-center fw-600">New Password</label>
											<div class="col-sm-9">
												<input type="password" class="form-control" id="pw-old" v-model="password.new">
											</div>
										</div>

										<div class="form-group row">
											<label for="pw-old" class="col-sm-3 col-form-label text-left d-flex align-items-center fw-600">New Password (Again)</label>
											<div class="col-sm-9">
												<input type="password" class="form-control" id="pw-old" v-model="password.reentry">
											</div>
										</div>

										<div class="form-group row mt-5">
											<div class="col text-center">
												<button class="btn btn-danger" v-on:click="updatePassword">
													<span v-if="!updating">Update Password</span>
                                					<span v-if="updating"><i class="fa fa-circle-o-notch fa-spin logging-in"></i></span>
												</button>
											</div>
										</div>


									</div>
									<div class="tab-pane fade" id="v-pills-social" role="tabpanel" aria-labelledby="v-pills-social-tab">
										<div class="form-group row">
											<label for="facebook" class="col-sm-4 col-form-label text-left d-flex align-items-center fw-600">Facebook</label> 
											<div class="col-sm-8">
												<div class="input-group">
													<span class="input-group-addon">https://www.facebook.com/</span>
													<input type="text" class="form-control" id="facebook" v-model="settings.facebook">
												</div>
											</div>
										</div>

										<div class="form-group row">
											<label for="twitter" class="col-sm-4 col-form-label text-left d-flex align-items-center fw-600">Twitter</label> 
											<div class="col-sm-8">
												<div class="input-group">
													<span class="input-group-addon">https://www.twitter.com/</span>
													<input type="text" class="form-control" id="twitter" v-model="settings.twitter">
												</div>
											</div>
										</div>

										<div class="form-group row">
											<label for="instagram" class="col-sm-4 col-form-label text-left d-flex align-items-center fw-600">Instagram</label> 
											<div class="col-sm-8">
												<div class="input-group">
													<span class="input-group-addon">https://www.instagram.com/</span>
													<input type="text" class="form-control" id="instagram" v-model="settings.instagram">
												</div>
											</div>
										</div>

										<div class="row">
											<div class="col-md-12 text-left">
												<strong>Notice: </strong> It is imparitive that you only put what is after the URL for each. <br /> <br />

												<strong>Example: </strong> If your profile is accessible via this link: <code>https://www.facebook.com/bamastormchaser</code>, you would <strong>only</strong> enter <code>bamastormchaser</code> into the box.
											</div>
										</div>

										<div class="form-group row mt-5">
											<div class="col text-center">
												<button class="btn btn-primary" v-on:click="updateSettings">
													<span v-if="!updating">Update</span>
                                					<span v-if="updating"><i class="fa fa-circle-o-notch fa-spin logging-in"></i></span>
												</button>
											</div>
										</div>
									</div>

								</div>

							</div>
						</div>
					</div>
				</div>
			
			</div>
		</div>
	</div>

</template>

<script>

	import { EventBus } from '@/utils/events';
    import * as Config from '@/config'
    import { mapState, mapGetters } from 'vuex';

	export default {
		name: 'HelloWorld',
		data () {
			return {
				settings: {
					address: null,
					city: null,
					state: null,
					zipcode: null,
					phone: null,
					facebook: null,
					twitter: null,
					instagram: null,
				},
				password: {
					old: null,
					new: null,
					reentry: null,
				},
				updating: false,
				error: null,
				messagePage: null,
				messageText: null,
			}
		},
		computed: {
			...mapGetters([
                'userInfo'
            ]),
		},
		mounted() {
			this.getUserSettings();
		},
		methods: {
			...mapGetters([
                'getAuthorizationHeader',
            ]),
			getUserSettings() {
                var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/stringer/account/settings", this.getAuthorizationHeader()).then((response) => {
                    _this.settings = response.data
                });
			},
			updateSettings() {
				var _this = this;
				this.updating = true;
				this.$http.post(Config.apiPath + "/api/v2/stringer/account/settings", {settings: this.settings}, this.getAuthorizationHeader()).then((response) => {
					
					_this.error = response.data.error
					_this.messagePage = response.data.messagePage
					_this.messageText = response.data.messageText

					_this.updating = false;
                });
			},
			updatePassword() {
				var _this = this;
				this.updating = true;
				this.$http.post(Config.apiPath + "/api/v2/stringer/account/password", {old_password: this.password.old, password: this.password.new, repassword: this.password.reentry}, this.getAuthorizationHeader()).then((response) => {
					
					_this.error = response.data.error
					_this.messagePage = response.data.messagePage
					_this.messageText = response.data.messageText

					_this.updating = false;
                });
			},
		}
		
	}
</script>

<style scoped>

	.user-panel {
		/* background-color: #F6F7F8; */
		/* padding: 0px; */
	}

	.settings-stacked-tabs {
        border-radius: 4px;
        font-weight: 300;
    }

    .nav {
        margin-bottom: 0;
        padding-left: 0;
        list-style: none;
    }
    .nav > li {
        position: relative;
        display: block;
    }

    .settings-stacked-tabs li a:active, .settings-stacked-tabs li a:hover, .settings-stacked-tabs li a:link, .settings-stacked-tabs li a:visited {
        background-color: white;
    }

    .nav > li > a {
        position: relative;
        display: block;
        padding: 10px 15px;
    }

    .settings-stacked-tabs a {
        border-bottom: 1px solid #e4ecf2;
        border-left: 3px solid transparent;
        color: #636b6f;
    }



    .panel-flush .panel-body, .panel-flush .panel-header {
        padding: 0;
    }

    .settings-stacked-tabs .active a {
        border-left: 3px solid #1e73be;
    }

</style>
